import { XMarkIcon } from '../../../automationStudioIcons';
import styles from '../../../../../styles/automationStudio/automationStudio.module.scss';

/**
 * AIAssistantOverlay - Contextual AI assistance
 * TODO: Phase 6 (Future) - Build AI chat interface
 */
export default function AIAssistantOverlay({
    onClose,
    currentState: _currentState,
    selectedStep: _selectedStep,
    executionResults: _executionResults,
}) {
    return (
        <div className={styles.aiAssistantOverlay}>
            <div className={styles.aiAssistantHeader}>
                <h2 className={styles.asTypoSubtitle2} style={{ margin: 0 }}>✨ AI Assistant</h2>
                <button type="button" onClick={onClose} className={styles.asIconButton} aria-label="Close AI assistant">
                    <XMarkIcon style={{ width: '20px', height: '20px' }} />
                </button>
            </div>

            <div className={styles.aiAssistantContent}>
                <p className={`${styles.asTypoBody2} ${styles.asTextSecondary}`} style={{ textAlign: 'center', marginTop: 32 }}>
                    AI Assistant Coming in Phase 6
                </p>
                <p className={`${styles.asTypoCaption} ${styles.asTextSecondary}`} style={{ textAlign: 'center', marginTop: 16, display: 'block' }}>
                    Future features:
                </p>
                <ul style={{ marginTop: '16px' }}>
                    <li><span className={styles.asTypoCaption}>Contextual error analysis</span></li>
                    <li><span className={styles.asTypoCaption}>Suggested fixes</span></li>
                    <li><span className={styles.asTypoCaption}>Script optimization</span></li>
                    <li><span className={styles.asTypoCaption}>Natural language queries</span></li>
                </ul>
            </div>
        </div>
    );
}
